<template>
  <div class="app" :class="classes">
    <splash-screen v-if="!ready"></splash-screen>
    <layout v-else></layout>
    <modal></modal>
    <notification></notification>
    <context-menu></context-menu>
    <global-search ref="globalSearch"></global-search>
    <keyboard-shortcuts></keyboard-shortcuts>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Layout from './Layout.vue';
import Modal from './Modal.vue';
import Notification from './Notification.vue';
import ContextMenu from './ContextMenu.vue';
import SplashScreen from './SplashScreen.vue';
import GlobalSearch from './GlobalSearch.vue';
import KeyboardShortcuts from './KeyboardShortcuts.vue';
import networkSvc from '../services/networkSvc';
import tempFileSvc from '../services/tempFileSvc';
import localDbSvc from '../services/localDbSvc';

const themeClasses = {
  light: ['app--light'],
  dark: ['app--dark'],
  sepia: ['app--sepia'],
  nord: ['app--nord'],
  'solarized-light': ['app--solarized-light'],
  'solarized-dark': ['app--solarized-dark'],
  dracula: ['app--dracula'],
  monokai: ['app--monokai'],
};

export default {
  name: 'App',
  components: {
    Layout,
    Modal,
    Notification,
    ContextMenu,
    SplashScreen,
    GlobalSearch,
    KeyboardShortcuts,
  },
  data: () => ({
    ready: false,
  }),
  computed: {
    ...mapGetters('data', ['computedSettings']),
    classes() {
      const result = themeClasses[this.computedSettings?.colorTheme];
      return Array.isArray(result) ? result : themeClasses['solarized-light'];
    },
  },
  async created() {
    try {
      await localDbSvc.init();
      await networkSvc.init();
      this.ready = true;
      tempFileSvc.setReady();
    } catch (err) {
      if (err?.message === 'RELOAD') {
        globalThis.location.reload();
      } else if (err) {
        console.error(err);
        this.$store.dispatch('notification/error', err);
      }
    }
  },
};
</script>
